import { v4 as uuid } from "uuid"
import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { PriceCategoryBaseModel } from "./categories/priceCategoryBaseModel"
import { PriceType } from "../constants/priceType"
import { IsNotEmpty } from "class-validator"

@Serializable
export class PriceRootModel {
  uid: string = uuid()
  @IsNotEmpty({
    message: "select_option_error",
    groups: ["agreement_type"],
  })
  priceType: number | null = null
  @IsNotEmpty({
    message: "select_option_error",
    groups: ["agreement_type"],
  })
  currency: string = ""
  isActive: boolean = false
  version: number = 1
  activatedAt: string = ""
  expiredAt: string = ""
  categories: PriceCategoryBaseModel[] = []

  constructor(
    data: {
      uid: string
      priceType: number
      currency: string
      isActive: boolean
      version: number
      activatedAt: string
      expiredAt: string
      categories: any[]
    } | null = null,
  ) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
